import { styled } from "@mui/material/styles";

const StyledLogin = styled("div")(
  ({ theme }) => `

.login-wrap {
  width: 35%;
  margin: 80px auto;
  padding: 30px 0;

  @media screen and (max-width: 1024px) {
    width: 60%;
    margin: 80px auto;
    }
    
    @media screen and (max-width: 480px) {
    margin: 32px auto;
    width: 80%;
  }
}
.login-header {
  font-family: Lexend;
  color: ${theme.palette.primary.main};
  font-weight: 400;
  font-size: 32px;
  font-style: normal;
  line-height: normal;
  @media screen and (max-width: 1024px) {
    font-size: 28px;
  }
  @media screen and (max-width: 480px) {
    font-size: 24px;
  }  
}
.login-sub-header{
  margin-top: 12px;
  margin-bottom: 32px;
  font-family: Lexend;
  color: ${theme.palette.customColor.secondarySecond};
  font-weight: 300;
  font-size: 16px;
  font-style: normal;
  line-height: 24px;
}
.login-textfeilds {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.checkbox-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.checkbox-wrap a {
  font-weight: 400;
  font-size: 14px;
  font-style: normal;
  line-height: 15px;
  color: ${theme.palette.secondary.main};
  cursor: pointer;
  text-decoration: underline;
}  

.terms-condition{
  font-weight: 400;
  font-size: 12px;
  font-style: normal;
  line-height: 15px;
}

.login {
  width: 100%;
  text-align: center;
  margin-top: 15px;
  font-weight: 400;
  font-size: 16px;
  font-style: normal;
  line-height: 20px;
  color: ${theme.palette.customColor.secondarySecond};
    @media screen and (max-width: 480px) {
      font-size: 14px;
    }  
  }
  .login a {
    color: ${theme.palette.primary.main};
    text-decoration: underline;
    margin-left: 3px;
  }  
.terms-condition span {
    color: ${theme.palette.secondary.main};
    cursor: pointer;
    text-decoration: underline;
}
.submit-btn {
  width: 100%;
  padding: 10px;
  margin-top: 16px;
  font-size: 16px;
  text-transform: none;
}          
`
);

export default StyledLogin;
